module.exports = __webpack_public_path__ + "static/img/03_hc.a3c4dd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/swiperImg/secondLine/03_hc.png
// module id = lWwf
// module chunks = 0